
import { Component, Prop, Vue } from '~/utility/pu-class-decorator'
import { PuCampsiteCardLocationSectionProps } from './PuCampsiteCardLocationSectionProps'

@Component
export default class PuCampsiteCardLocationSection
  extends Vue
  implements PuCampsiteCardLocationSectionProps
{
  @Prop({ required: true })
    hierarchyStringShort: string

  @Prop({ required: true })
    isPointSearch: boolean

  @Prop({ required: false })
    distance: { km: number; mi: number }

  get showDistance() {
    return this.isPointSearch && !!this.distance
  }
}
